var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckmark = function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 66 66"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 18,
    fill: "#f5c445",
    "data-name": "Ellipse 162",
    rx: 23,
    ry: 18,
    transform: "translate(12 16)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007297",
    d: "M33 0a33 33 0 1 0 33 33A33 33 0 0 0 33 0m17.121 26.121-21 21a3 3 0 0 1-4.242 0l-9-9a3 3 0 0 1 4.242-4.242L27 40.758l18.879-18.879a3 3 0 0 1 4.242 4.242",
    "data-name": "Path 152"
  })));
};
export default SvgIconCheckmark;